import React, { ChangeEventHandler } from 'react';
import { UseFormRegisterReturn, UseFormSetValue } from 'react-hook-form';
import { RefreshCw } from 'lucide-react';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import BaseInput from '@/components/form/base/BaseInput.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';

function formatPromoCode(value: string): string {
  return value.toUpperCase();
}

function generatePromoCode(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let code = '';
  for (let i = 0; i < 12; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export const PromoCodeInput = ({
  label = 'Kod promocyjny',
  register,
  setValue,
  fieldName,
  placeholder = 'Np. ABCDEFGHIJKL',
  required = false,
  disabled = false,
  error,
  hint,
  showGenerate = true,
}: {
  label?: string;
  register: UseFormRegisterReturn;
  setValue: UseFormSetValue<any>;
  fieldName: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
  showGenerate?: boolean;
}) => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(fieldName, formatPromoCode(e.target.value));
  };

  const handleGenerate = () => {
    setValue(fieldName, generatePromoCode());
  };

  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <div className="flex w-full items-center justify-between">
        {label && (
          <InputLabel label={label} required={required} disabled={disabled} />
        )}
        {showGenerate && !disabled && (
          <button
            type="button"
            onClick={handleGenerate}
            className="flex items-center gap-1 text-xs text-accent-600 hover:text-accent-700"
          >
            <RefreshCw size={12} />
            Generuj kod
          </button>
        )}
      </div>
      <BaseInput
        type="text"
        register={register}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        onChange={handleChange}
      />
      <InputError error={error} />
      <InputHint hint={hint} />
    </div>
  );
};
